import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import React, {useState} from 'react';
import {useScrollEffect} from 'react-viewport-utils';
import {PushNotification} from './PushNotification';

interface PushNotificationComponentProps {
  onSuccess?: VoidFunction;
}

/*
 *  Created and used to avoid translation problem when used on legacy pages
 */
export function withPushNotification<T extends PushNotificationComponentProps>(
  InnerComponent: React.ComponentType<React.PropsWithChildren<T>>,
) {
  const WrappedComponent: React.FC<React.PropsWithChildren<T>> = props => {
    const isPushNotificationEnabled = useIsSoftFeatureToggleActive(
      'web_mobile_push_notifications',
    );
    const [showPushNotification, setShowPushNotification] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false);

    useScrollEffect(
      scroll => {
        if (isPushNotificationEnabled && scroll.y >= 200) {
          setShowPushNotification(true);
        }
      },
      {
        deferUpdateUntilIdle: true,
        priority: 'low',
        disableScrollUpdates: !isPushNotificationEnabled,
      },
      [isPushNotificationEnabled],
    );

    return (
      <>
        <InnerComponent
          {...props}
          onSuccess={() => {
            setIsSuccess(true);
          }}
        />
        {showPushNotification && isSuccess && (
          <PushNotification type="osp_push_trg" />
        )}
      </>
    );
  };
  return WrappedComponent;
}
